module.exports = __webpack_public_path__ + "img/jed-pro.d6ae4b91.jpg";